// extracted by mini-css-extract-plugin
export default {"invalid-error":"FranchiseForm_invalid-error__v34Io"};